<div class="flex items-center max-w-sm">
  <div class="relative w-full">
    <app-text [label]="label()" [(value)]="value">
      <app-icons icon [icon]="'magnifying-glass'"></app-icons>
    </app-text>

    <button type="button" (click)="value.set('')" [class.!opacity-0]="!value().toString().length" [class.!pointer-events-none]="!value().toString().length" class="transition-opacity duration-400 absolute inset-y-0 end-0 flex items-center pe-3 opacity-100" aria-label="Clear {{label()}} filter search">
      <app-icons width="20" class="text-gray-500 dark:text-gray-400 hover:text-brand dark:hover:text-white cursor-pointer" icon="circle-x"></app-icons>
    </button>
  </div>

  @if (button()) {
    <button type="submit" (click)="search.emit(value().toString())" class="cursor-pointer p-2.5 ms-2 text-base sm:text-sm font-medium text-white bg-brand rounded-lg border border-brand hover:bg-brand-strong focus:ring-4 focus:outline-none focus:ring-brand-medium">
      <app-icons [icon]="'magnifying-glass'"></app-icons>
      <span class="sr-only">{{label()}}</span>
    </button>
  }
</div>
